const baseurl = {
  stage1baseurl: "https://stage.diro.live/Zuul-1.0/",
  stage2baseurl: "https://stage2.diro.live/Zuul-1.0/",
  prodbaseurl: "https://prod.dirolabs.com/Zuul-1.0/",
};

const stage2 = {
  env: "stage2",
  verifyHash: baseurl.stage2baseurl + "uploadKyc-2.0/verifyhash",
  // Via the m2 wrapper, not the Zuul gateway directly: prod.dirolabs.com enforces a
  // CORS origin allowlist (https *.diro.io / *.diro.live only) and 403s the preflight
  // for the widget's opaque "null" origin. m2 calls Zuul server-side, so no Origin
  // header is involved. prodeu uses api.diro.io. DIRO-8628.
  get_lastclicked_link: "https://api2.diro.live/org/api/getlastclickedlink",
  getverificationlink:    "https://api2.diro.live/org/api/getVerificationLink",
  update_session: baseurl.stage2baseurl + "User-2.0/updatesession",
  getProcessedDataFromChatGpt:
    "https://api2.diro.live/textract/getlivegptfeedback",
  integrityScore: "https://api2.diro.live/sourceVerify/integrityScore",
  logUrl: "https://trails.diro.live/api/event_logs",
  sentryLogs: "https://utils.diro.live/uploadSentryLogs",
  oneshotupload: baseurl.stage2baseurl + "Oneshotupload-2.0/oneshotupload",
  feedbackurl: baseurl.stage2baseurl + "User-2.0/feedback",
  engagementCallback: "https://api2.diro.live/ube/engagement-status-upload",
  sentryDNS:"https://92bf5e7e118c6ab151ca1b08c650d2d3@o305199.ingest.us.sentry.io/4507372417318912",
  s3Upload:"https://api2.diro.live/org/api/s3uploadCapture",
  imageToPdfApiUrl:"https://img2.diro.live/imagetopdf/image-to-pdf-converter",
}

const stage1 = {
  env: "stage1",
  verifyHash: baseurl.stage1baseurl + "uploadKyc-2.0/verifyhash",
  get_lastclicked_link: baseurl.stage1baseurl + "User-2.0/getlastclickedlink",
  getverificationlink:
    baseurl.stage1baseurl + "organization-2.0/getverificationlinkpoc",
  update_session: baseurl.stage1baseurl + "User-2.0/updatesession",
  getProcessedDataFromChatGpt:
    "https://api1.diro.live/textract/getlivegptfeedback",
  integrityScore: "https://api1.diro.live/sourceVerify/integrityScore",
  logUrl: "https://trails.diro.live/api/event_logs",
  sentryLogs: "https://utils.diro.live/uploadSentryLogs",
  oneshotupload: baseurl.stage1baseurl + "Oneshotupload-2.0/oneshotupload",
  feedbackurl: baseurl.stage1baseurl + "User-2.0/feedback",
  engagementCallback: "https://api1.diro.live/ube/engagement-status-upload",
  pdfpreview: baseurl.stage1 + "Oneshotupload-2.0/previewdocument?filename=",
  sentryDNS:"https://92bf5e7e118c6ab151ca1b08c650d2d3@o305199.ingest.us.sentry.io/4507372417318912",
  imageToPdfApiUrl:"https://img1.diro.live/imagetopdf/image-to-pdf-converter",
  origin:"https://json1.diro.live",
  s3Upload:"https://api1.diro.live/org/api/s3uploadCapture",
};

const prodeu = {
  env: "prodeu",
  verifyHash: baseurl.prodbaseurl + "uploadKyc-2.0/verifyhash",
  get_lastclicked_link: baseurl.prodbaseurl + "User-2.0/getlastclickedlink",
  getverificationlink:
    // "https://prod.dirolabs.com/Zuul-1.0/organization-2.0/getverificationlinkpoc",
    "https://api.diro.io/org/api/getVerificationLink",
  update_session: baseurl.prodbaseurl + "User-2.0/updatesession",
  getProcessedDataFromChatGpt:
    "https://api.diro.io/textract/getlivegptfeedback",
  integrityScore: "https://api.diro.io/sourceVerify/integrityScore",
  logUrl: "https://trails.diro.io/api/event_logs",
  sentryLogs: "https://logs.diro.live/uploadSentryLogs",
  oneshotupload: baseurl.prodbaseurl + "Oneshotupload-2.0/oneshotupload",
  feedbackurl: baseurl.stage1baseurl + "User-2.0/feedback",
  engagementCallback: "https://api.diro.io/ube/engagement-status-upload",
  sentryDNS:"https://92bf5e7e118c6ab151ca1b08c650d2d3@o305199.ingest.us.sentry.io/4507372417318912",
  s3Upload:"https://api.diro.io/org/api/s3uploadCapture",
  imageToPdfApiUrl:"https://img.diro.io/imagetopdf/image-to-pdf-converter",
};


const CDN = {
  ...stage2,    // change to stage1 or prodeu for different environments for the sake of creating
  env: "CDN",
  button: true,
  buttonId: document?.getElementById('reactWidget')?.getAttribute('data-buttonid') || "O.IE-3KW0dD-RVrl-sandbox",
  trackId: document?.getElementById('reactWidget')?.getAttribute('data-trackid') || "",
  isWidget: true,  // Add this flag to indicate it's a widget
};


export { stage1 };
export { prodeu };
export { stage2 as env };
export { CDN };
